import React from 'react';
import './NavBar.css';
import timestampLogo from '../../assets/timestamp.png';

const navLinks = [
  { label: 'Timestamp', href: '#timestamp' },
  { label: 'Services', href: '#services' },
];

const NavBar = () => {
  const handleVideoClick = () => {
    window.open('https://www.youtube.com', '_blank', 'noopener,noreferrer');
  };

  return (
    <header className="navbar">
      <div className="navbar-container">
        <a href="/" className="navbar-brand">
          <span className="brand-symbol">
            <img src={timestampLogo} alt="Timestamp Logo" className="navbar-logo" />
          </span>
          <span className="brand-name">Stamp Sage</span>
        </a>

        <nav className="navbar-nav">
          <ul className="navbar-menu">
            {navLinks.map((link) => (
              <li key={link.label} className="navbar-item">
                <a href={link.href} className="navbar-link">
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <button type="button" className="navbar-btn" onClick={handleVideoClick}>
          Do more with video
        </button>
      </div>
    </header>
  );
};

export default NavBar;
